import React, { useState } from "react";
import { Typography } from "antd";
import logo from "../../images/logo_white_bg.png";
import fallback from "../../images/mohasebe-hoghughui.png";
const { Paragraph } = Typography;

const CarouselSlide = (props) => {
  const { image, text, select, imagePath } = props;

  const [imageHolder, setImageHolder] = useState(image);

  const handleBreakImage = () => {
    setImageHolder("");
  };

  return (
    <div onClick={select} className="slides-wrapper">
      {/* <Link className="slides-wrapper" to={where ? where : ""}> */}
      <div>
        <div className="slides">
          {imageHolder && imageHolder.length ? (
            <img
              src={imagePath}
              alt={text}
              className={`slides-icon`}
              onError={handleBreakImage}
            />
          ) : text !== "محاسبه گر حقوقی" ? (
            <img src={logo} alt={text} className={`slides-icon-fallback`} />
          ) : (
            <img
              src={fallback}
              alt={text}
              className={`slides-icon`}
              onError={handleBreakImage}
            />
          )}
          <Paragraph ellipsis={{ rows: 2 }} className="slides-text">
            {text}
          </Paragraph>
        </div>
      </div>
      {/* </Link> */}
    </div>
  );
};

export default CarouselSlide;
